
// You can write more code here

/* START OF COMPILED CODE */

import Obstacle from "./Obstacle";
/* START-USER-IMPORTS */
import { BodyTypes } from '../../LevelManager';
import { ObstacleEffectController } from '../../ObstacleEffectController';
import { SplatEffectsLayer } from '../../../SplatEffectsLayer';
import { app } from '../../../core/App';
/* END-USER-IMPORTS */

export default class ObstacleLeafPile extends Obstacle {

  constructor(scene: Phaser.Scene, x?: number, y?: number, texture?: string, frame?: number | string) {
    super(scene, x ?? 105, y ?? 51.5, texture || "game", frame ?? "obstacle-leaf-pile.png");

    // this (prefab fields)
    this.spawnOffsetY = -10;
    this.slowStrength = 0.5;
    this.hitEffect = "impact";

    /* START-USER-CTR-CODE */
    // Write your code here.
    /* END-USER-CTR-CODE */
  }

  /* START-USER-CODE */

  public init() {
    let rect: MatterJS.BodyType = this.scene.matter.bodies.rectangle(this.x, this.y, this.displayWidth, this.displayHeight - 50, {
      label: BodyTypes.Obstacle,
      isSensor: true,
      isStatic: true
    });
    rect.position.y += this.spawnOffsetY;

    this.setExistingBody(rect);

    super.init();
  }

  public onHit(wasPlayer: boolean, isSingleUse: boolean, hitPointX: number, delay: number) {
    // this.alpha = 0;
    if(!this.hasBeenHit){
      app.audioHandler.playSound(this.scene, 'SndObstacleRustle', 'sfx');
    }
    this.hasBeenHit = true;

    this.scene.events.emit(ObstacleEffectController.events.ShowEffect, this, this.x, this.y);

    if (wasPlayer) {
      this.scene.events.emit(SplatEffectsLayer.events.SplatLeaf, hitPointX - this.scene.cameras.main.scrollX, this.y - this.scene.cameras.main.scrollY, 5);
    }

    super.onHit(wasPlayer, true, hitPointX, 500);
  }

  /* END-USER-CODE */
}

/* END OF COMPILED CODE */

// You can write more code here
